import React, { useState } from "react";
import { PythonService } from "../../api/python";
import { showNotification } from "../../utils";
import "./batch_shared.css";

const PaceExpediente = () => {
  const [processing, setProcessing] = useState(false);
  const [downloading, setDownloading] = useState(false);
  const [processResult, setProcessResult] = useState(null);
  const [processComplete, setProcessComplete] = useState(false);

  const handleProcess = async () => {
    setProcessing(true);
    try {
      const result = await PythonService.processStudents();
      setProcessResult(result);
      setProcessComplete(true);
      showNotification(
        "Éxito",
        `Cotejo completado: ${result.ok} de ${result.total} estudiantes`,
        "success"
      );
    } catch (error) {
      setProcessResult(null);
      setProcessComplete(false);
    } finally {
      setProcessing(false);
    }
  };

  const handleDownload = async () => {
    setDownloading(true);
    try {
      await PythonService.downloadExcelReport();
      showNotification("Éxito", "Reporte descargado correctamente", "success");
    } catch (error) {
      // error toast handled in api layer
    } finally {
      setDownloading(false);
    }
  };

  return (
    <div className="batch-panel">
      <h3>Expediente PACE</h3>
      <p className="batch-panel-description">
        Primero actualiza el estado académico de todos los estudiantes en la
        base de datos. Luego descarga el reporte Excel con los datos
        procesados.
      </p>

      <div className="batch-step">
        <h4>Paso 1 — Actualizar estudiantes</h4>
        <p>Ejecuta el cotejo masivo sobre todos los estudiantes PACE.</p>
        <input
          className="button_register batch-action-btn"
          type="button"
          value={processing ? "Procesando..." : "Actualizar estudiantes"}
          disabled={processing}
          onClick={handleProcess}
        />
        {processResult && (
          <div className="batch-result-summary">
            <pre>{JSON.stringify(processResult, null, 2)}</pre>
          </div>
        )}
      </div>

      <div className="batch-step">
        <h4>Paso 2 — Descargar reporte Excel</h4>
        <p>Disponible después de completar el paso 1 en esta sesión.</p>
        <input
          className="button_register batch-action-btn"
          type="button"
          value={downloading ? "Descargando..." : "Descargar reporte Excel"}
          disabled={!processComplete || downloading}
          onClick={handleDownload}
        />
      </div>
    </div>
  );
};

export default PaceExpediente;
